import React, { useState, useEffect } from "react";
import AuthHeader from "./AuthHeader";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Steps, Input, Button, Row, Col, Card, Space } from "antd";

function SignUp(props) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [signUpInfo, setSignUpInfo] = useState({ subscription_plans_xref: 1, promo_code_xref: 7 });
  const [signUpWaiting, setSignUpWaiting] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const nextStep = () => {
    if (!signUpInfo?.first_name || signUpInfo?.first_name?.length === 0) return props.MakeNotification("info", "Please enter your first name.");
    if (!signUpInfo?.last_name || signUpInfo?.last_name?.length === 0) return props.MakeNotification("info", "Please enter your last name.");
    if (!signUpInfo?.email || signUpInfo?.email?.search(/[a-zA-Z0-9_.\-+\[\]"']+@[a-zA-Z0-9_.\-+\[\]"']+[.][a-zA-Z0-9_.\-+\[\]"']+/) === -1)
      return props.MakeNotification("info", "Please enter a valid email.");
    if (!signUpInfo?.password || signUpInfo?.passwor < 8) return props.MakeNotification("info", "Your password must be at least 8 characters long.");
    if (!signUpInfo?.password || !signUpInfo?.password_confirm || signUpInfo?.password !== signUpInfo?.password_confirm) return props.MakeNotification("warning", "The passwords entered don't match.");
    setCurrentStep(currentStep + 1);
  };
  const previousStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const CompleteSignUp = async (event) => {
    if (!signUpInfo?.first_name || signUpInfo?.first_name?.length === 0) return props.MakeNotification("info", "Please enter your first name.");
    if (!signUpInfo?.last_name || signUpInfo?.last_name?.length === 0) return props.MakeNotification("info", "Please enter your last name.");
    if (!signUpInfo?.email || signUpInfo?.email?.search(/[a-zA-Z0-9_.\-+\[\]"']+@[a-zA-Z0-9_.\-+\[\]"']+[.][a-zA-Z0-9_.\-+\[\]"']+/) === -1)
      return props.MakeNotification("info", "Please enter a valid email.");
    if (!signUpInfo?.password || signUpInfo?.passwor < 8) return props.MakeNotification("info", "Your password must be at least 8 characters long.");
    if (!signUpInfo?.password || !signUpInfo?.password_confirm || signUpInfo?.password !== signUpInfo?.password_confirm) return props.MakeNotification("warning", "The passwords entered don't match.");
    if (!signUpInfo?.company_name || signUpInfo?.company_name?.length === 0) return props.MakeNotification("warning", "Please fill out the company name.");
    if (!signUpInfo?.phone_number || signUpInfo?.phone_number?.length < 3) return props.MakeNotification("warning", "Please enter the company phone number.");

    props.MakeNotification("success", "Signing up! One moment...");
    setSignUpWaiting(true);
    let response = await props.AxiosRequest("/api/user/sign-up", { ...signUpInfo });
    if (response.data.status === "success") navigate("/auth/login");
  };

  const CheckPromoCode = async (code = null) => {
    let response = await props.AxiosRequest("/api/subscription-promos/check", { code: code || signUpInfo.promo_code });
    if (response.data.status === "error") return props.MakeNotification("error", "Invalid Code");
    if (response.data.status === "invalid") return props.MakeNotification("error", "Invalid Code");
    if (response.data.status === "success") {
      props.MakeNotification("success", 'Promo  "' + (code || signUpInfo.promo_code) + '" Applied!', 3500, "topRight", true);
      setSignUpInfo({ ...signUpInfo, promo_code_xref: response.data.promo.id, promo_code: code || signUpInfo.promo_code });
    }
  };
  const steps = [
    {
      title: "First",
      content: (
        <Row gutter={[16, 8]} className="mx-4">
          <Col span={24}>
            <label className="col-form-label w-100">First Name *</label>
            <Input
              value={signUpInfo?.first_name}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, first_name: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label w-100">Last Name *</label>
            <Input
              value={signUpInfo?.last_name}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, last_name: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label w-100">Email *</label>
            <Input
              value={signUpInfo?.email}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, email: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label w-100">Password *</label>
            <Input
              type="password"
              value={signUpInfo?.password}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, password: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label w-100">Confirm Password *</label>
            <Input
              type="password"
              value={signUpInfo?.password_confirm}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, password_confirm: e.target.value });
              }}
            />
          </Col>
        </Row>
      ),
    },
    {
      title: "Second",
      content: (
        <Row gutter={[16, 8]} className="mx-4">
          <Col span={24}>
            <label className="col-form-label w-100">Company Name *</label>
            <Input
              value={signUpInfo?.company_name}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, company_name: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label w-100">Address Line 1 </label>
            <Input
              value={signUpInfo?.address_line_1}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, address_line_1: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label w-100">Address Line 2 </label>
            <Input
              value={signUpInfo?.address_line_2}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, address_line_2: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label w-100">City</label>
            <Input
              value={signUpInfo?.city}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, city: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label w-100">State </label>
            <Input
              value={signUpInfo?.state}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, state: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label w-100">Zip </label>
            <Input
              value={signUpInfo?.zip}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, zip: e.target.value });
              }}
            />
          </Col>
          <Col span={24}>
            <label className="col-form-label w-100">Phone Number * </label>
            <Input
              value={signUpInfo?.phone_number}
              onChange={(e) => {
                setSignUpInfo({ ...signUpInfo, phone_number: e.target.value });
              }}
            />
          </Col>
          <Col span={12}></Col>
          <Col span={12}>
            <label className="col-form-label w-100">Promo Code </label>
            <Space.Compact>
              <Input
                value={signUpInfo?.promo_code}
                onChange={(e) => {
                  setSignUpInfo({ ...signUpInfo, promo_code: e.target.value.toUpperCase() });
                }}
              />
              <Button
                onClick={() => {
                  CheckPromoCode();
                }}
              >
                Apply
              </Button>
            </Space.Compact>
          </Col>
        </Row>
      ),
    },
  ];

  useEffect(() => {
    let code = searchParams?.get("promo")?.toUpperCase();
    if (code) {
      CheckPromoCode(code);
    }
  }, []);

  return (
    <div>
      <AuthHeader />
      <Row gutter={[16, 16]} className="mt-4">
        <Col span={8}></Col>
        <Col span={8}>
          <div className="text-center mt-4">
            <h1 className="h2">Sign Up</h1>
            <p className="lead">Get ready to bill more and work less</p>
          </div>
          <Card>
            <Row gutter={[16, 16]}>
              {/* <Steps
              // direction="vertical"
              current={currentStep}
              items={items}
            /> */}

              <Col span={24}>{steps[currentStep].content}</Col>

              <Col span={24} className="text-center mt-4">
                {currentStep > 0 && (
                  <Button
                    style={{
                      margin: "0 8px",
                    }}
                    onClick={() => previousStep()}
                  >
                    Previous
                  </Button>
                )}
                {currentStep < steps.length - 1 && (
                  <Button type="primary" onClick={() => nextStep()}>
                    Next
                  </Button>
                )}
                {currentStep === steps.length - 1 && (
                  <Button
                    type="primary"
                    onClick={() => {
                      CompleteSignUp();
                    }}
                  >
                    Sign Up
                  </Button>
                )}
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={8}></Col>
      </Row>
    </div>
  );
}

export default SignUp;
